export const fonts = {
  primary: 'Franklin Gothic, serif'
};
